export const withModalSearchParams = (
  current: URLSearchParams,
  modalType: string,
  bookingId?: number,
): URLSearchParams => {
  const next = new URLSearchParams(current);
  next.set('popup', modalType);
  if (bookingId) next.set('bookingId', String(bookingId));
  else next.delete('bookingId');
  return next;
};

export const withoutModalSearchParams = (current: URLSearchParams): URLSearchParams => {
  const next = new URLSearchParams(current);
  next.delete('popup');
  next.delete('bookingId');
  return next;
};
